import React from 'react'
import PlaySalonAnalysis from '../components/dashboard/PlaySalonAnalysis'

const PlaySalonAnalysisPage = () => <PlaySalonAnalysis />

export default PlaySalonAnalysisPage
